import { render, staticRenderFns } from "./TaskConfigurationHeader.vue?vue&type=template&id=2addd764&"
import script from "./TaskConfigurationHeader.vue?vue&type=script&lang=ts&"
export * from "./TaskConfigurationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TaskConfigurationHeader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports